var exports = {
  "k": "x31de4314--6be3f7--container",
};

module.exports = exports;
